import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';

import { RequestService } from '../request';
import { IEntity, IFieldType } from './defs';

const fieldTypes: IFieldType[] = [
  {
    id: 'string',
    title: 'Texto'
  },
  {
    id: 'number',
    title: 'Número'
  },
  {
    id: 'time',
    title: 'Hora'
  },
  {
    id: 'date',
    title: 'Fecha'
  },
  {
    id: 'category',
    title: 'Lista de valores'
  },
  {
    id: 'boolean',
    title: 'Verdadero/Falso'
  },

]

@Injectable({
  providedIn: 'root'
})
export class EntitiesService {

  private baseUrl = '/api/entities';

  constructor(
    private request: RequestService
  ) { }
  
  public getEntities(): Observable<IEntity[]> {
    return this.request.get(this.baseUrl);
  }

  public getEntityById(id: number): Observable<IEntity[]> {
    return this.request.get(`${this.baseUrl}/${id}`);
  }

  public createUpdateEntity(request: IEntity): Observable<IEntity> {
    if (!request.id) {
      return this.request.post(`${this.baseUrl}`, request);
    } else {
      return this.request.put(`${this.baseUrl}/${request.id}`, request);
    }
    
  }

  public deleteEntity(ids: number[]): Observable<IEntity[]> {
    return forkJoin(ids.map(id => this.request.delete(`${this.baseUrl}/${id}`)));
  }

  public getFieldTypes(): IFieldType[] {
    return fieldTypes;
  }

}
